import { Controller, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  // Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Stack,
} from '@mui/material';
import { post } from 'api';
import { enqueueSnackbar } from 'notistack';
import { authPaths } from 'routes/paths';
import * as yup from 'yup';
import IconifyIcon from 'components/base/IconifyIcon';
import PasswordTextField from 'components/common/PasswordTextField';

const validationSchema = yup.object().shape({
  oldPassword: yup.string().required('Old Password is required'),
  newPassword: yup
    .string()
    .required('New Password is required')
    .min(6, 'Password must be at least 6 characters'),
  confirmNewPassword: yup
    .string()
    .oneOf([yup.ref('newPassword'), null], 'Passwords must match')
    .required('Confirm New Password is required'),
});

const PasswordChange = ({ open, setOpen }) => {
  const navigate = useNavigate();
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      oldPassword: '',
      newPassword: '',
      confirmNewPassword: '',
    },
  });

  const onSubmit = async (data) => {
    let res = await post('users/password_change', {
      oldPassword: data.oldPassword,
      newPassword: data.newPassword,
    });

    if (res.status == 200) {
      enqueueSnackbar(res.message, {
        variant: 'success',
        autoHideDuration: 3000,
      });
      navigate(authPaths.login);
    } else {
      enqueueSnackbar(res.message, {
        variant: 'error',
        autoHideDuration: 3000,
      });
    }

    reset();

    setOpen(false);
  };

  const handleClose = () => {
    reset();

    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      component="form"
      onSubmit={handleSubmit(onSubmit)}
    >
      {/* Header */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ p: 3, pb: 2 }}
      >
        <DialogTitle sx={{ p: 0 }}>Password Change</DialogTitle>

        <IconButton onClick={handleClose}>
          <IconifyIcon icon="material-symbols:close-rounded" />
        </IconButton>
      </Stack>

      {/* Body */}
      <DialogContent sx={{ px: 3, py: 2 }}>
        <Grid container spacing={2}>
          {/* Dispatch Meta */}
          <Grid item size={{ xs: 12, sm: 12 }}>
            <Controller
              name="oldPassword"
              control={control}
              render={({ field }) => (
                <PasswordTextField
                  {...field}
                  fullWidth
                  size="large"
                  id="oldPassword"
                  label="Old Password"
                  // defaultValue={defaultCredential?.password}
                  error={!!errors.oldPassword}
                  helperText={<>{errors.oldPassword?.message}</>}
                />
              )}
            />
          </Grid>

          <Grid item size={{ xs: 12, sm: 12 }}>
            <Controller
              name="newPassword"
              control={control}
              render={({ field }) => (
                <PasswordTextField
                  {...field}
                  fullWidth
                  size="large"
                  id="newPassword"
                  label="New Password"
                  // defaultValue={defaultCredential?.password}
                  error={!!errors.newPassword}
                  helperText={<>{errors.newPassword?.message}</>}
                />
              )}
            />
          </Grid>
          <Grid item size={{ xs: 12, sm: 12 }}>
            <Controller
              name="confirmNewPassword"
              control={control}
              render={({ field }) => (
                <PasswordTextField
                  {...field}
                  fullWidth
                  size="large"
                  id="confirmNewPassword"
                  label="Confirm Password"
                  // defaultValue={defaultCredential?.password}
                  error={!!errors.confirmNewPassword}
                  helperText={<>{errors.confirmNewPassword?.message}</>}
                />
              )}
            />
          </Grid>
        </Grid>
      </DialogContent>

      {/* Footer */}
      <DialogActions sx={{ p: 3, pt: 1 }}>
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="contained" type="submit">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PasswordChange;
